export class TempLibModel {
    initials: string;
    lastNamePrefix: string;
    lastName: string;
    dateOfBirth: string;
    streetName: string;
    houseNumber: string;
    houseNumberSuffix: string;
    postalCode: string;
    city: string;
    gender: string;
    email: string;
    country: string;
    language: string;
    phoneNumber: string;
    streetNameDutch: string;
    houseNumberDutch: string;
    houseNumberSuffixDutch: string;
    postalCodeDutch: string;
    cityDutch: string;
    borrowerType: string;
    orderId: string;
}